export default "__VITE_PUBLIC_ASSET__471beb9f__"